export default function ({ isHMR, app, store, route, params, error, redirect }) {
  if (!store.state.languages.labels[app.i18n.locale]) {
    store.dispatch('languages/setLabels', error)
  } else {
    app.i18n.setLocaleMessage(app.i18n.locale, store.state.languages.labels[app.i18n.locale])
    store.commit('SET_LOADED', {
      type: 'labels',
      value: true
    })
  }

  if(app.$dayjs) app.$dayjs.locale(app.i18n.locale)
}
